// @flow

/**
 * @module Constants/Auth
 * @desc Auth Constants
 */

import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @constant {Object} AuthConstants
 * @memberof Auth
 */
export const AuthConstants = keyMirror({
  AUTH_SIGN_IN: undefined,
  AUTH_SIGN_OUT: undefined,
  UPDATE_LAST_LOGIN_DATE: undefined,
});



// WEBPACK FOOTER //
// ./src/constants/auth.js